const initialState = () => ({
  all: []
})

export default {
  namespaced: true,
  state: initialState(),
  getters: {
    withService: state => state.all.filter(f => f.service),
    validations: state => {
      const validations = {}
      state.all.forEach(f => (validations[f.name] = {}))
      return validations
    }
  },
  actions: {
    async findServices({ dispatch, getters }) {
      // iterate and fetch all services
      for (let customField of getters.withService) {
        console.log('find', customField.name, customField.service, customField)
        await dispatch(`provider/${customField.service}/find`, null, {
          root: true
        })
      }
    }
  },
  mutations: {
    assign(state, data) {
      state.all = data
    }
  }
}
